<template>
  <div
    class="tw-m-4 tw-bg-white tw-shadow-lg tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
  >
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p
        class="tw-mx-4 tw-block tw-text-eko-orange tw-mt-8 tw-font-bold tw-text-2xl"
      >
        Account Information
      </p>
    </div>
    <div v-if="account">
      <p class="tw-mx-4 tw-block">
        <strong>Name on Bank:</strong> {{ account.nameOnBank }}
      </p>
      <p class="tw-mx-4 tw-block">
        <strong>Bank Name:</strong> {{ account.bankName }}
      </p>
      <p class=" tw-px-4">
        <strong>Account Number:</strong> {{ account.accountNumber }}
      </p>
    </div>
    <div
      v-if="!account && !loading"
      class="tw-bg-idea-light md:tw-bg-white  tw-w-full tw-flex tw-items-center tw-justify-center"
    >
      <div class="tw-block tw-w-full tw-mx-auto">
        <div class="tw-m-4 tw-bg-white tw-px-8 tw-pt-6 tw-pb-8 tw-mb-4">
          <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6">
            <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="title"
              >
                Bank Name
              </label>
              <div class="tw-relative">
                <select
                  class="tw-block tw-appearance-none tw-w-full tw-bg-gray-200 tw-border tw-border-gray-200 tw-text-gray-700 tw-py-3 tw-px-4 tw-pr-8 tw-rounded tw-leading-tight focus:tw-outline-none  focus:tw-border-gray-500"
                  id="grid-state"
                  v-model="selected"
                >
                  <option disabled value="undefined">Select a bank</option>
                  <option v-for="bank in banks" :key="bank" :value="bank">{{
                    bank.name
                  }}</option>
                </select>
              </div>
              <p v-if="errors.selected" class="tw-text-xs tw-text-red-500">
                Please select your bank.
              </p>
            </div>

            <div class="tw-w-full md:tw-w-1/2 tw-px-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-left tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="grid-last-name"
                >Name(As found on Bank Account)</label
              >
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-border tw-border-gray-200 tw-rounded tw-py-3 tw-px-4 tw-leading-tight focus:tw-bg-white focus:tw-border-gray-500"
                id="grid-last-name"
                type="text"
                placeholder="Doe"
                v-model="data.nameOnBank"
              />
              <p v-if="errors.nameOnBank" class="tw-text-xs tw-text-red-500">
                Please enter your Name.
              </p>
            </div>
          </div>
          <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6">
            <div class="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-left tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="grid-first-email"
                >Account Number</label
              >
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-border tw-border-gray-200 tw-rounded tw-py-3 tw-px-4 tw-leading-tight focus:tw-bg-white focus:tw-border-gray-500"
                id="grid-first-email"
                type="email"
                placeholder="mail@gmail.com"
                v-model="data.accountNumber"
              />
              <p v-if="errors.accountNumber" class="tw-text-xs tw-text-red-500">
                Please enter your account Number.
              </p>
            </div>
          </div>

          <vue-element-loading
            v-if="loading"
            :active="loading"
            :is-full-screen="true"
          />
          <div class="tw-flex tw-items-center tw-justify-between">
            <button
              @click.prevent="submit"
              class="tw-bg-eko-orange hover:tw-bg-eko-dark tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
              type="button"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      loading: false,
      error: false,
      errors: {},
      user: {},
      token: "",
      admin: null,
      banks: [],
      selected: null,
      account: {},
    };
  },
  components: {},
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.getAccount();
    this.getBanks();
  },
  methods: {
    getAccount() {
      axios
        .get(`${this.$baseUrl}/account/get/${this.user._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.account = response.data.account;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
    getBanks() {
      axios
        .get(`https://api.paystack.co/bank`, {})
        .then((response) => {
          console.log(response.data);
          this.banks = response.data.data;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
    submit() {
      this.error = false;
      this.loading = false;
      this.errors = {};
      let deny = false;

      if (!this.selected) {
        this.errors.selected = true;
        deny = true;
      }
      if (!this.data.nameOnBank) {
        this.errors.nameOnBank = true;
        deny = true;
      }
      if (!this.data.accountNumber) {
        this.errors.accountNumber = true;
        deny = true;
      }

      if (deny) {
        this.loading = false;
        return;
      }
      this.loading = true;

      this.data.owner_id = this.user._id;
      this.data.bankSlug = this.selected.slug;
      this.data.bankCode = this.selected.code;
      this.data.bankLongCode = this.selected.longcode
        ? this.selected.longcode
        : "No Long Code";
      this.data.bankName = this.selected.name;

      const self = this;
      self.loading = true;
      axios
        .post(`${this.$baseUrl}/account/create`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          self.loading = false;
          self.success = true;
          this.$swal("Success!", "Account created successfully!", "success");
          this.account = response.data.account;
          this.data = {};
          this.getAccount();
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style scoped>
.log {
  height: 100vh;
  overflow: auto;
}
.my-img,
.logo {
  width: 60%;
  height: 60%;
  margin: auto;
}
</style>
